import * as THREE from "three";

export const HolzarebitLabels = [

  {
    Id: "Annotation_Bauweise",
    Titel: "Galerie Bauweise",
    TitelEn: "Gallery construction",
    Position: new THREE.Vector3(367.886, 22.1341, -717.364),
    Rotation: new THREE.Vector3(0.0,0.0,30),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: -3,
    follow: false,
    lowModelCamZoom: 20
  },


  {
    Id: "Annotation_Schachtbau",
    Titel: "Galerie Ausbauarten",
    TitelEn: "Gallery finishing types",
    Position: new THREE.Vector3(480.687, 18.0898, -280.491),
    Rotation: new THREE.Vector3(0.0,0.0,120),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: -3,
    follow: false,
    lowModelCamZoom: 20
  },

  {
    Id: "Annotation_PicGalerie_Glows",
    Titel: "Galerie Ausbauarten",
    TitelEn: "Gallery finishing types",
    Position: new THREE.Vector3(445.44, 18.0898, -219.442),
    Rotation: new THREE.Vector3(0.0,0.0,120),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: -3,
    follow: false,
    lowModelCamZoom: 20
  },

 {
    Id: "PicGalerie_Soleleitung",
    Titel: "Galerie Soleleitung",
    TitelEn: "Gallery brine pipe",
    Position: new THREE.Vector3(556.159, 18.0898, -411.213),
    Rotation: new THREE.Vector3(0.0,0.0,120),
    Scale: 1.5,
    isIFrame: false,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: -3,
    follow: false,
    lowModelCamZoom: 20
  },

  {
    Id: "Annotation_Bohrer",
    Titel: "Holzrohrbohrer",
    TitelEn: "Wood drill",
    Position: new THREE.Vector3(289.574, 0.426128, -217.8),
    Rotation: new THREE.Vector3(0.0, 0.0, 0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/2ad22422afd74171b5bcbb1533b43f68/embed",
    offset: 15,
    offsetUp: 30,
    follow: true,
    lowModelCamZoom: 15,
  },

  {
    Id: "Annotation_Breithacke",
    Titel: "Breithacke",
    TitelEn: "Wide hoe",
    Position: new THREE.Vector3(161.686, 0.679318, -719.096),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/64a9d3cc26cf42289f8d58e9cd4a2025/embed",
    offset: -16,
    offsetUp: 30,
    follow: true,
    lowModelCamZoom: 25,
  },

  {
    Id: "Annotation_Papiermaschin",
    Titel: "Papiermaschine",
    TitelEn: "Paper machine",
    Position: new THREE.Vector3(56.7881, 0.426128, -340.85),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.3,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/82505869842a4ae68f474ea913426362/embed",
    offset: 0,
    offsetUp: 30,
    follow: true,
    lowModelCamZoom: 28,
  },

  {
    Id: "Annotation_Zellstoffballen",
    Titel: "Zellstoffballen",
    TitelEn: "The last bale",
    Position: new THREE.Vector3(-37.852, 0.426128, -395.49),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/7d0a6c642b494e39b4118e1914c738c7/embed",
    offset: 0,
    offsetUp: 30,
    lowModelCamZoom: 25,
    follow: true,
  },

  {
    Id: "Annotation_Saege",
    Titel: "Maschinensäge",
    TitelEn: "Machine saw",
    Position: new THREE.Vector3(111.519, 0.679318, -610.205),
    Rotation: new THREE.Vector3(0.0, 0.0, -60),
    Scale: 2,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: 20,

    lowModelCamZoom: 20,
    follow: false,
  },

  {
    Id: "Annotation_StadlPauraSalzkuefel",
    Titel: "Salzküfel",
    TitelEn: "Salt barrels",
    Position: new THREE.Vector3(273.347, 1.67096, -704.434),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/d6936b48bf63438ab8066277901dcaed/embed",
    offset: 0,
    offsetUp: 20,
 
    lowModelCamZoom: 15,
    follow: true,
  },

  {
    Id: "Annotation_Salzkuefel",
    Titel: "Salzküfel",
    TitelEn: "Salt barrels",
    Position: new THREE.Vector3(501.175, 1.67096, -567.791),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/eb79e7797a6545e7a98dfd4d2f8c6884/embed",
    offset: 0,
    offsetUp: 14,

    lowModelCamZoom: 15,
    follow: true,
  },

  {
    Id: "Annotation_Salzschiff",
    Titel: "Salzzillen",
    TitelEn: "Salt rafts",
    Position: new THREE.Vector3(409.13, 1.67096, -658.516),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: 30,

    lowModelCamZoom: 70,
    follow: true,
  },

  {
    Id: "Annotation_Sappl",
    Titel: "Sappl",
    TitelEn: "Pickaxe",
    Position: new THREE.Vector3(136.575, 0.679318, -675.604),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 2,
    isIFrame: true,
    iFrameUrl:
      "https://sketchfab.com/models/947b66b106ff41429d5634746b0c8c96/embed",
    offset: -15,
    offsetUp: 30,

    lowModelCamZoom: 15,
    follow: true,
  },

  {
    Id: "Annotation_EbenseeSoleleitung",
    Titel: "Soleleitung",
    TitelEn: "Brine pipe",
    Position: new THREE.Vector3(415.072, 16.2096, -261.21),
    Rotation: new THREE.Vector3(0.0, 0.0, 0.0),
    Scale: 1.5,
    isIFrame: true,
    iFrameUrl:
      "",
    offset: 0,
    offsetUp: 15,

    lowModelCamZoom: 15,
    follow: true,
  },

];
